import { SunIcon, MoonIcon, ArrowsRightLeftIcon } from '@heroicons/react/24/outline';

type ShiftType = 'days_only' | 'nights_only' | 'both';

interface ShiftTypeIconProps {
  type: ShiftType;
  className?: string;
}

export const ShiftTypeIcon = ({ type, className = '' }: ShiftTypeIconProps) => {
  switch (type) {
    case 'days_only':
      return <SunIcon className={`h-5 w-5 text-yellow-500 ${className}`} />;
    case 'nights_only':
      return <MoonIcon className={`h-5 w-5 text-indigo-500 ${className}`} />;
    case 'both':
      return <ArrowsRightLeftIcon className={`h-5 w-5 text-purple-500 ${className}`} />;
    default:
      return null;
  }
}; 